import { getCoreAgentConversationSearchSlice } from './get';

export const { requestGetCoreAgentConversationSearch, resetGetCoreAgentConversationSearch } =
	getCoreAgentConversationSearchSlice.asyncActionCreators;
